import { CommonModule } from '@angular/common';
import { Component, inject, OnInit, output, signal } from '@angular/core';
import { AuditLogEntity } from '@domain';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { RaLoadingComponent } from '@shared/components';
import { RaModalComponent } from 'ra-ui';
import { RaEmptyComponent } from 'src/app/shared/components/ra-empty/ra-empty.component';
import { AuditDiffModalComponent } from 'src/app/modules/rapidocs/pages/audit/components/audit-diff-modal/audit-diff-modal.component';
import { DocumentHistoryService } from '../../services/document-history.service';
import { DocumentHistoryItemComponent } from './document-history-item.component';

/**
 * Drawer (slide da direita) com a timeline de alterações do documento aberto.
 * Visível para quem tem acesso ao documento (inclusive o cliente). Reaproveita o
 * `audit-diff-modal` (Monaco) para o antes/depois das edições de texto.
 */
@Component({
    selector: 'document-history-panel',
    templateUrl: 'document-history-panel.component.html',
    styleUrl: 'document-history-panel.component.scss',
    imports: [
        CommonModule,
        TranslatePipe,
        RaModalComponent,
        RaLoadingComponent,
        RaEmptyComponent,
        DocumentHistoryItemComponent,
        AuditDiffModalComponent,
    ],
    providers: [DocumentHistoryService],
})
export class DocumentHistoryPanelComponent implements OnInit {
    public close = output<void>();

    /** Evento cujo diff está aberto (null = fechado). */
    public diffEvent = signal<AuditLogEntity | null>(null);

    public history = inject(DocumentHistoryService);

    private _translate = inject(TranslateService);

    ngOnInit(): void {
        this.history.load(1, false);
    }

    /** Lê `before`/`after` do metadata como string (para o Monaco). */
    public metaStr(ev: AuditLogEntity | null, key: 'before' | 'after'): string {
        const value = (ev?.metadata as Record<string, unknown> | undefined)?.[key];
        if (typeof value === 'string') return value;
        return value == null ? '' : JSON.stringify(value);
    }

    public diffTitle(ev: AuditLogEntity | null): string {
        const session = (ev?.metadata as { sessionName?: string } | undefined)?.sessionName;
        return session
            ? this._translate.instant('audit.diff.textEditWithSession', { session })
            : this._translate.instant('audit.diff.textEdit');
    }
}
